<template>
  <select
    v-model="selectedLocale"
    class="float-end"
    :class="{ 'pj-input': !adminConsole, 'admin-console': adminConsole }"
    @change="changeLang($event)"
  >
    <option v-for="lang in locales" :key="lang.locale" :value="lang.locale">
      {{ lang.name }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { CURRENT_LANG, supportedLanguages } from "@/i18n";
import { ref } from "vue";

defineProps({
  adminConsole: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const selectedLocale = ref(CURRENT_LANG);

const locales = ref(supportedLanguages.data.locales);

const changeLang = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  localStorage.setItem("lang", target.value);
  window.location.reload();
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
select {
  padding: 5px;
}

.admin-console,
.admin-console:hover,
.admin-console:focus {
  background-color: $pj-color-white !important;
  border: none !important;
}
</style>
